(function () {
    angular.module('app')
        .component('compile', {
            bindings: {
                'content': '<',
                'ready': '<?'
            },
            controller: CompileController
        });

    CompileController.$inject = ['$compile', '$element', '$scope', '$attrs'];
    function CompileController($compile, $element, $scope, $attrs) {
        var ctrl = this;

        ctrl.$onInit = function () {
            if (!$attrs.ready || ctrl.ready) {
                $element.html(ctrl.content);
                $compile($element.contents())($scope.$parent);
            }
        }
    }
})();